import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Avatar, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { fetchUserImage } from 'services';

const useStyles = makeStyles(() => ({
  avatar: {
    width: 100,
    height: 100,
  },
  name: {
    fontWeight: 'bold',
  },
}));

const SummaryCardBusinessCard = ({ id, name, position }) => {
  const classes = useStyles();
  const [imageUrl, setImageUrl] = useState();

  useEffect(() => {
    const fetchImage = async () => {
      try {
        setImageUrl(await fetchUserImage(id));
      } catch (e) {
        setImageUrl(undefined);
      }
    };

    fetchImage();
  }, [id]);

  return (
    <Grid container alignItems="center" spacing={4}>
      <Grid item>
        <Avatar className={classes.avatar} src={imageUrl} />
      </Grid>
      <Grid item>
        <Typography variant="h6" className={classes.name}>
          {name}
        </Typography>
        {position ? <Typography variant="body1">{position}</Typography> : null}
      </Grid>
    </Grid>
  );
};

SummaryCardBusinessCard.defaultProps = {
  position: undefined,
};

SummaryCardBusinessCard.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  position: PropTypes.string,
};

export default SummaryCardBusinessCard;
